// Function to get speaker details by their IDs
export const getGuestsByIds = (guestIds, guests) => {

  // Map through each speaker ID and find the corresponding speaker object from the speakers array
  return guestIds.map(id => guests.find(guest => guest.id === id));

};